// 9fbef606107a605d69c0edbcd8029e5d 
const SITEMAP_CONSTANTS = {
  FETCH_SITEMAP_DATA: 'FETCH_SITEMAP_DATA',
  SET_SITEMAP_DATA: 'SET_SITEMAP_DATA',
};
export default SITEMAP_CONSTANTS;
